import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments';
import { GeoLocationData } from '../store/models/geo-location-data.model';
import { HttpService, IResponseInfo } from 'i2g-ng-utils';

@Injectable()
export class AppService {
  constructor(private _httpService: HttpService) {}

  getGeoLocation(): Observable<GeoLocationData> {
    const url = `${environment.gatewayUrl}/location/geoip?precision=country`;

    return this._httpService
      .get(url)
      .pipe(map(({ body }: IResponseInfo) => new GeoLocationData(body)));
  }
}
